var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrows(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 51,
    viewBox: "0 0 52 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.5421 15.9442C51.3089 15.1774 51.3089 13.9342 50.5421 13.1674L38.0467 0.671988C37.2799 -0.0947924 36.0367 -0.0947924 35.2699 0.671988C34.5031 1.43877 34.5031 2.68197 35.2699 3.44875L46.377 14.5558L35.2699 25.6628C34.5031 26.4296 34.5031 27.6728 35.2699 28.4396C36.0367 29.2064 37.2799 29.2064 38.0467 28.4396L50.5421 15.9442ZM2.40454 16.5193H49.1537V12.5923H2.40454V16.5193Z",
    fill: "#00A7B5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.01625 34.4169C0.249474 35.1837 0.249474 36.4269 1.01625 37.1937L13.5117 49.6891C14.2784 50.4559 15.5216 50.4559 16.2884 49.6891C17.0552 48.9223 17.0552 47.6791 16.2884 46.9123L5.18139 35.8053L16.2884 24.6983C17.0552 23.9315 17.0552 22.6883 16.2884 21.9215C15.5216 21.1547 14.2785 21.1547 13.5117 21.9215L1.01625 34.4169ZM49.1538 33.8418L2.40463 33.8418L2.40463 37.7688L49.1538 37.7688L49.1538 33.8418Z",
    fill: "#00A7B5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.4757793a9d30e151a11c69025181acfb.svg";
export { ForwardRef as ReactComponent };